import { createSlice } from "@reduxjs/toolkit";

import { checkVerifyCodeThunk, sendVerifyCodeThunk } from "state/action/verify";

// ** Create inialstate **
const initialState = {
  checkVerifyCode: {
    data: null,
    isPending: false,
    isFulfilled: false,
    isRejected: false,
    err: null,
  },
  sendVerifyCode: {
    data: null,
    isPending: false,
    isFulfilled: false,
    isRejected: false,
    err: null,
  },
  reRequestCode: {
    isVisibile: false,
  },
};

// ** Create slice **
export const verifySlice = createSlice({
  name: "verify",
  initialState,
  reducers: {
    setReRequestCode: (state, action) => {
      return {
        ...state,
        reRequestCode: action.payload,
      };
    },
    setClearReRequestCode: (state, _) => {
      return {
        ...state,
        reRequestCode: {
          isVisibile: false,
        },
      };
    },
    setClearCheckRegisterVerifyCode: (state, _) => {
      return {
        ...state,
        checkVerifyCode: {
          data: null,
          isPending: false,
          isFulfilled: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearReSendRegisterVerifyCode(state, _) {
      return {
        ...state,
        sendVerifyCode: {
          data: null,
          isPending: false,
          isFulfilled: false,
          isRejected: false,
          err: null,
        },
      };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(checkVerifyCodeThunk.pending, (state, _) => {
        return {
          ...state,
          checkVerifyCode: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(checkVerifyCodeThunk.fulfilled, (state, action) => {
        return {
          ...state,
          checkVerifyCode: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(checkVerifyCodeThunk.rejected, (state, action) => {
        return {
          ...state,
          checkVerifyCode: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      .addCase(sendVerifyCodeThunk.pending, (state, _) => {
        return {
          ...state,
          sendVerifyCode: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(sendVerifyCodeThunk.fulfilled, (state, action) => {
        return {
          ...state,
          sendVerifyCode: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(sendVerifyCodeThunk.rejected, (state, action) => {
        return {
          ...state,
          sendVerifyCode: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const verifyAction = {
  ...verifySlice.actions,
  checkVerifyCodeThunk,
  sendVerifyCodeThunk,
};

// Helper functions to access parts of state
export function selectVerify(state) {
  return state?.verify;
}
export function selectReRequestCode(state) {
  return state?.verify?.reRequestCode;
}

export default verifySlice.reducer;
